module.exports = "https://trybtryb-legacy.web.app/img/chat_gray.92e1706b.svg";